var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1281_514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 16.625C20.125 17.0891 19.9406 17.5342 19.6124 17.8624C19.2842 18.1906 18.8391 18.375 18.375 18.375H2.625C2.16087 18.375 1.71575 18.1906 1.38756 17.8624C1.05937 17.5342 0.875 17.0891 0.875 16.625V7C0.875 6.53587 1.05937 6.09075 1.38756 5.76256C1.71575 5.43437 2.16087 5.25 2.625 5.25H6.125L7.875 2.625H13.125L14.875 5.25H18.375C18.8391 5.25 19.2842 5.43437 19.6124 5.76256C19.9406 6.09075 20.125 6.53587 20.125 7V16.625Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.875C12.433 14.875 14 13.308 14 11.375C14 9.442 12.433 7.875 10.5 7.875C8.567 7.875 7 9.442 7 11.375C7 13.308 8.567 14.875 10.5 14.875Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1281_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.97c6ee3a07d6f731063fc31ca6d6317a.svg";
export { ForwardRef as ReactComponent };